import {usePPTWebView} from "../../hooks/usePPTWebView";
import {
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE,
    INSERTING_TEXT, POLL_SHARE_MODE, POLL_TEXT, POLL_TYPE,
    PPT_SAVED_ACTIVITY_DESCRIPTION, PPT_WEBVIEW_ADD_POLL_TO_SLIDES_BUTTON,
    SAVED_ACTIVITY_TEXT, VIEW_ALL_ACTIVITIES_PLACEHOLDER_TEXT,
    VIEW_ALL_ACTIVITIES_TEXT,
} from "../../utils/constants";
import classes from "../CreateQuizPage/ActivityEditor.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as SAVED_SUCCESSFULLY} from "../../images/activity_saved_successfuly_image.svg";
import React, {useState} from "react";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {deCapitalizeWord, notifyError} from "../../utils/helpers";
import {INSERT_SLIDE_FAIL} from "../../utils/toast-message-constants";


export default function PPTActivitySaved({pollKey, pollCode, savedActivity}) {

    const { goPollsPage, goPollsPageDirectly} = usePPTWebView();
    const {checkAppRunning} = ReportApiCalls();
    const {updatePollDetails} = PollApiCalls();

    const [isProcessing, setIsProcessing] = useState(false);

    const onClickViewAll = () => {
        goPollsPageDirectly(savedActivity.pollType);
    }

    const onClickInsert = async () => {
        const {pollType, pollShareMode, syncLmsOption="", lmsHomeUrl="", questions=[]} = savedActivity;
        if (pollType === POLL_TYPE.ATTENDANCE) {
            try {
                const pollDetails = {};
                setIsProcessing(true);
                pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_EACH;
                checkAppRunning(pollKey, pollCode, POLL_SHARE_MODE.SHARE_EACH, pollType, 1).catch(err => {
                    console.log(err);
                    notifyError(INSERT_SLIDE_FAIL.replaceAll(
                        ACTIVITY_TYPE_PLACEHOLDER,
                        pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT
                    ));
                    setIsProcessing(false);
                });
                await updatePollDetails(pollKey, pollCode, pollDetails, true);
                // goInsertWaitingPage(pollType);
            } catch (err) {
                console.log(err);
                setIsProcessing(false);
            }
        } else {
            goPollsPage({pollKey, pollCode, pollType, pollShareMode, syncLmsOption, lmsHomeUrl, totalQuestions: questions.length});
        }
    }

    return (
        <div
            className={`${classes.parentContainer} ${classes.straightColumnLayout}`}
            style={{alignItems: "center", gap: 20, padding: 20}}
        >
            <span style={{flex: 1}}/>
            <SAVED_SUCCESSFULLY style={{marginBottom: 20}}/>
            <span className={classes.title} style={{fontSize: 20}}>
                {SAVED_ACTIVITY_TEXT.replaceAll(
                    ACTIVITY_TYPE_PLACEHOLDER,
                    savedActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? ATTENDANCE
                        : POLL_TEXT
                )}
            </span>
            <span className={classes.description}>
                {PPT_SAVED_ACTIVITY_DESCRIPTION.replaceAll(
                    ACTIVITY_TYPE_PLACEHOLDER,
                    savedActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? deCapitalizeWord(ATTENDANCE)
                        : deCapitalizeWord(POLL_TEXT)
                )}
            </span>
            <div style={{display: "flex", marginTop: 20, gap: 10}}>
                <YuJaButton
                    type={"secondary"}
                    style={{width: 180, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whitespace: "nowrap"}}
                    onClick={onClickViewAll}
                >
                    {
                        VIEW_ALL_ACTIVITIES_PLACEHOLDER_TEXT.replaceAll(
                            ACTIVITY_TYPE_PLACEHOLDER,
                            savedActivity.pollType === POLL_TYPE.ATTENDANCE
                                ? ATTENDANCE
                                : POLL_TEXT
                        )
                    }
                </YuJaButton>

                <YuJaButton
                    disabled={isProcessing}
                    style={{minWidth: 180, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whitespace: "nowrap"}}
                    onClick={onClickInsert}
                >
                    {
                        PPT_WEBVIEW_ADD_POLL_TO_SLIDES_BUTTON.replaceAll(
                            ACTIVITY_TYPE_PLACEHOLDER,
                            savedActivity.pollType === POLL_TYPE.ATTENDANCE
                                ? ATTENDANCE
                                : POLL_TEXT
                        )
                    }
                </YuJaButton>

            </div>
            <span style={{flex: 1}}/>
        </div>
    );
}